import type { FunctionComponent } from 'react';

import { SetupTaskPanel } from './components/SetupTaskPanel';
import type { TaskId } from './constants';
import type { TaskPanelContext } from './task-panel-types';

const TASK_PANEL_REGISTRY: Partial<Record<TaskId, FunctionComponent<TaskPanelContext>>> = {
    'company-information': SetupTaskPanel,
    'data-upload': SetupTaskPanel,
    'define-purpose': SetupTaskPanel,
};

export const getTaskPanelComponent = (taskId: TaskId): FunctionComponent<TaskPanelContext> | undefined =>
    TASK_PANEL_REGISTRY[taskId];
